export const itemIsInIndexRange = (itemIndex: number, currentPage: number, itemsPerPage: number) => {
  const minIndex = -itemsPerPage + 1 + itemsPerPage * currentPage - 1;
  const maxIndex = minIndex + itemsPerPage - 1;
  return minIndex <= itemIndex && itemIndex <= maxIndex;
};
